import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import QuoteProductDetail from '../../quotes/entities/quoteProductDetail';
import { QuoteProductConfiguration } from '../../quotes/quoteProductConfiguration';
import ProductBucketQuoteProductSelectionItemComponent from '../../quotes/step3/ProductBucketQuoteProductSelectionItemComponent';
import { makeConcealable } from '@ami/react/core';

class ProductBucketQuoteProductSelectionComponent extends React.Component {
  static propTypes = {
    entity: PropTypes.instanceOf(QuoteProductDetail).isRequired,
    onUpdate: PropTypes.func.isRequired,
    quoteProductConfiguration: PropTypes.instanceOf(QuoteProductConfiguration)
      .isRequired,
    products: PropTypes.array.isRequired,
    onFinishBucketConfiguration: PropTypes.func.isRequired,
  };

  onUpdateEntity(property, value) {
    var entity = this.props.entity;
    entity[property] = value;
    this.props.onUpdate(new QuoteProductDetail({ ...entity }));
  }

  render() {
    const { entity, onUpdate, quoteProductConfiguration, products, onFinishBucketConfiguration } =
      this.props;
    return (
      <Fragment>
        <div className="row justify-content-center text-center mb-2">
          <h5>Which bucket?</h5>
        </div>
        <table className={`table table-mobile step3-product-table`}>
          <tbody>
            {products.map((product, idx) => (
              <ProductBucketQuoteProductSelectionItemComponent
                key={idx}
                product={product}
                entity={entity}
                onUpdate={onUpdate}
                quoteProductConfiguration={quoteProductConfiguration}
                onFinishBucketConfiguration={(completed) => {
                  onFinishBucketConfiguration(completed);
                }}
              />
            ))}
          </tbody>
        </table>
      </Fragment>
    );
  }
}

export default makeConcealable(ProductBucketQuoteProductSelectionComponent);
